<!--
 * @Author: your name
 * @Date: 2020-05-14 17:35:22
 * @LastEditTime: 2020-06-11 10:31:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /edu_admin/Users/zhoulei/Desktop/work/ft_oa/resume/src/components/info-source/info-source.vue
-->
<template>
  <div class="info-source-wrap clearfix">
    <el-radio-group v-model="checkedCities">
      <el-col
        :key="city"
        :class="[index === 6 || index === 7 ? 'is-relative' : '']"
        :style="[
          checkedCities.includes('Internal') && index == 6
            ? { width: '75%' }
            : '',
        ]"
        v-for="(city, index) in cities"
      >
        <el-radio :id="index === 0 ? 'checked1' : ''" :label="city">{{
          city
        }}</el-radio>
        {{ index }}
        <el-input
          v-if="checkedCities.includes('Others') && index === 7"
          class="other-info"
          v-model="otherInfo"
          placeholder="Please Specify"
        ></el-input>
        <span
          class="red"
          v-if="checkedCities.includes('Internal') && index === 6"
          >*</span
        >
        <span
          class="red"
          v-if="checkedCities.includes('Internal') && index === 6"
          >*</span
        >
        <el-input
          :disabled="inptUse"
          placeholder="Person Name"
          v-model="innerPerson"
          @blur="inptnameblur"
          @input="inptname"
          id="innerSourcePerson"
          style="width: 130px"
          v-if="checkedCities.includes('Internal') && index === 6"
          class="inner-source-person"
        ></el-input>
        <el-input
          :disabled="inptUse"
          v-if="checkedCities.includes('Internal') && index === 6"
          v-model="innerSourcePhone"
          @blur="inptnameblur"
          @input="inptphone"
          type="number"
          maxlength="11"
          id="innerSourcePhone"
          class="inner-source-number"
          placeholder="Mobile Number"
        ></el-input>
        <div
          class="inner-source-txt"
          v-if="checkedCities.includes('Internal') && index === 6"
        >
          or
          <!--<div
            style="
              color: red;
              position: absolute;
              left: 30px;
              z-index: 100;
              top: -10px;
            "
          >
            *
          </div>-->
        </div>
        <el-input
          :disabled="inptCode"
          class="inner-source-code"
          @input="inptcode"
          @blur="getNameByCode"
          v-model="recommendationcode"
          style="width: 140px"
          placeholder="Referral Code"
          v-if="checkedCities.includes('Internal') && index === 6"
        ></el-input>
      </el-col>
    </el-radio-group>
  </div>
</template>

<script>
import axios from "axios";
const infoSources = [
  "Job Portal",
  "MyCareeFuture",
  "School Career Fair",
  "Job fair",
  "External Referral",
  "Kangaroo.Study Website",
  "Internal referral",
  "Others"
];
export default {
  data: () => ({
    cities: infoSources,
    checkedCities: "",
    otherInfo: "",
    innerPerson:"",
    innerSourcePerson: "",
    innerSourcePhone: "",

    //九月份新增内推码
    recommendationcode: "",
    inptUse: false,
    inptCode: false,
    isCodeSuccess: true,
  }),
  methods: {
    inptcode(val) {
      console.log(val);
      if (val != "") {
        this.innerPerson = ''
        this.innerSourcePerson = ''
        this.innerSourcePhone = ''
        this.inptUse = true;
      }
    },
    inptname(val) {
      if (val !== "") {
        this.recommendationcode = ''
        this.innerSourcePerson = val
        this.inptCode = true;
        console.log(this.innerSourcePerson,"返回状态")
      }
    },
    inptphone(val) {
      if (val !== "") {
        this.recommendationcode = ''
        this.inptCode = true;
      }
    },
    inptnameblur() {
      if (this.innerSourcePerson === "" || this.innerSourcePhone === "") {
        this.inptCode = false;
      }
    },
    getNameByCode() {
      if (this.recommendationcode !== "") {
        axios
          .get("https://www.fangtian.me/service/wechat-srv/gteByCode", {
            params: {
              code: this.recommendationcode,
            },
          })
          .then((response) => {
            if (response.data) {
              this.innerSourcePerson = response.data.name;
            } else {
              this.$message.error("Invalid Code");
              this.recommendationcode = "";
              this.inptUse = false;
              this.innerSourcePerson = ""
            }
          })
          .catch((err) => {
            this.$message.error("获取失败");
            return err;
          });
      } else if (this.recommendationcode === "") {
        this.inptUse = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.info-source-wrap {
  .el-col {
    margin-top: 20px;
    width: 25%;
  }

  .is-relative {
    position: relative;

    .red {
      position: absolute;
      top: -7px;
      left: 153px;
      font-size: 12px;
      color: #f03b3b;
      z-index: 99;

      &:last-of-type {
        left: 288px;
      }
    }

    .inner-source-person {
      position: absolute;
      top: -12px;
      left: 150px;
    }

    .inner-source-number {
      top: -12px;
      left: 285px;
    }

    .inner-source-txt {
      position: absolute;
      top: 2px;
      left: 422px;
      font-size: 12px;
      color: #000000;
    }

    .inner-source-code {
      // position absolute
      top: -12px;
      left: 440px;
    }
  }

  .inner-source-person, .inner-source-number, .inner-source-code {
    position: absolute;
    width: 110px;

    .el-input__inner {
      height: 30px;
      line-height: 30px;
      font-size: 12px;
    }
  }

  .inner-source-number {
    width: 132px;
  }

  .other-info {
    position: absolute;
    top: -12px;
    left: 180px;
    width: 160px;

    .el-input__inner {
      height: 30px;
      line-height: 30px;
      font-size: 12px;
    }
  }

  .el-checkbox__label {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/info-source/info-source.vue